export const PROPERTIES_ROOMS_MAP: { [key: string]: string } = {
  rooms_studio: 'Studio',
  rooms_1: '1 BR',
  rooms_2: '2 BR',
  rooms_3: '3 BR',
  rooms_4: '4 BR',
  rooms_5: '5 BR',
  rooms_6: '6 BR',
  rooms_7: '7 BR',
};

export const BEDROOMS_ITEMS = [
  {
    value: null,
    text: 'Any',
  },
  {
    value: 0,
    text: 'Studio',
  },
  {
    value: 1,
    text: '1',
  },
  {
    value: 2,
    text: '2',
  },
  {
    value: 3,
    text: '3',
  },
  {
    value: 4,
    text: '4+',
  },
];

export enum PROPERTY_TYPE {
  APARTMENT = 'apartment',
  VILLA = 'villa',
  TOWNHOUSE = 'townhouse',
  STUDIO = 'studio',
}

export enum PROPERTY_STATUS {
  COMPLETED = 'Completed',
  OFF_PLAN = 'Off-plan',
  UNDER_CONSTRUCTION = 'Under-construction',
}

export enum PAYMENT_STATUS {
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  PENDING = 'Pending',
}

export const SALE_STATUSES = {
  ANNOUNCEMENT: 'announcement',
  LAUNCH: 'launch',
  ON_SALE: 'on_sale',
  PENDING: 'pending',
  PRE_SALE: 'presale(_e_o_i)',
  SOLD_OUT: 'sold_out',
};

// Canonical filter statuses per Notion #49 — four UI labels agents see.
export const CANONICAL_SALE_STATUS = {
  PRE_LAUNCH: 'Pre launch',
  EOI_STAGE: 'EOI Stage',
  ON_SALE: 'On Sale',
  SOLD_OUT: 'Sold out',
} as const;

export type CanonicalSaleStatus = (typeof CANONICAL_SALE_STATUS)[keyof typeof CANONICAL_SALE_STATUS];

// Backend → canonical UI label. Accepts both the legacy Geniemap codes
// ('announcement', 'pre_sale', 'on_sale', …) and the new Postgres status_code
// values ('LAUNCH', 'PRELAUNCH', 'EOI', 'ON_SALE', 'SOLD_OUT', 'COMPLETED',
// 'READY', 'UNKNOWN'). Anything unmapped returns '' (caller hides the badge).
export function toCanonicalSaleStatus(backendStatus?: string | null): CanonicalSaleStatus | '' {
  if (!backendStatus) return '';
  const normalized = backendStatus.toLowerCase().replace(/[\s()]+/g, '_');
  switch (normalized) {
    case 'announcement':
    case 'launch':
    case 'pending':
    case 'prelaunch':
      return CANONICAL_SALE_STATUS.PRE_LAUNCH;
    case 'presale':
    case 'presale__e_o_i_':
    case 'presale_e_o_i':
    case 'presale_eoi':
    case 'pre_sale':
    case 'eoi':
      return CANONICAL_SALE_STATUS.EOI_STAGE;
    case 'on_sale':
      return CANONICAL_SALE_STATUS.ON_SALE;
    case 'sold_out':
      return CANONICAL_SALE_STATUS.SOLD_OUT;
    default:
      return '';
  }
}

export const initialFilters = {
  query: '',
  orderBy: '',
  sortedBy: '',
  status: '',
  createdAt: [],
  membershipDate: [],
  refundStatus: '',
  refundDate: [],
  role: '',
  plan: '',
  assignedTo: '',
};
